import styled from 'styled-components';
import HeroBackground from "../../assests/images/banner-section/home-hero-background.webp";

export const BannerSection = styled.section`
    background-image:url(${HeroBackground});
    background-size: 100% 100%; 
    background-repeat: no-repeat;
    padding: 20px 0px;

    @media screen and (max-width: 1024px){
        margin-top: 87px;
        padding-top: 70px; 
        padding-bottom: 70px;
    }   
    
    @media screen and (max-width: 991px){
        padding-top: 170px;
        padding-bottom: 50px;
        margin-top: 0px;
    }
`;
export const BannerLeftSide = styled.div``; 

export const BannerTitle = styled.h1`
    color: #fff; 
    font-family: "Jost", sans-serif;
    font-size: 52px;
    font-weight: 700; 
    line-height: 66px;
    text-shadow: 0px 5px 20px #0000004D; 
    margin-bottom: 10px;
    @media screen and (max-width:1280px) {
        font-size: 50px; 
        line-height:65px;
     }
    @media screen and (max-width:1199px) {
        font-size: 40px;
        line-height:51px;
     }

    @media screen and (max-width:991px) { 
        font-size: 35px;
        line-height:51px;
    }
    
    @media screen and (max-width:767px) {
        font-size: 30px;
        line-height:45px;
    }
    
`;
export const BannerSubTitle = styled.p`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    margin-bottom:30px;
`;
export const BannerRightImage = styled.div` 

    @media only screen and (max-width: 991px){
        max-width: 500px;
        margin: 0 auto;
    }

    img{
        margin-left: -44px;

        @media only screen and (max-width: 1440px){
            width: 100%;
            margin-left: 0px;
        }
    }
`;

export const GetOurLatestNews = styled.section`
    padding-top: 70px;
    padding-bottom: 70px;
    @media screen and (max-width:1199px) {
        padding-top: 60px;
        padding-bottom: 60px;
    }
    @media screen and (max-width:991px) {
        padding-top: 50px;
        padding-bottom: 50px;
    }

    .btn-outline-success-blue.form-btn{
        margin-top: 35px;
    }
    
    .latest-news-right-side{
        @media screen and (max-width: 991px){
            margin-top: 30px;
        }
    }
`;

export const CategorySection = styled.section`
    background: transparent linear-gradient(180deg, #F1FEFF00 0%, #F1FEFF 78%, #F1FEFF 100%) 0% 0% no-repeat padding-box;
    padding-bottom: 70px;
    position: relative;
    @media screen and (max-width:1199px) { 
        padding-bottom: 30px;
    }


        .loader-cities{
        .loading {
          top:70%;
        }
    }
`;

export const SectionTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    @media screen and (max-width:575px) { 
        flex-wrap: wrap;
        gap:20px;
    }
    
    &.city-list-section-title{
        .dropdown-menu.show{
               border-radius: 12px !important;
                border: none !important;
                min-width: 190px !important;
                padding: 16px 18px 0px 23px;
            .dropdown-item {
                padding: 0 0 3px 0;
            }    
        }
    }
`;
export const SectionTitleText = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 36px;
    font-weight: bold;
    line-height: 46px;
    @media screen and (max-width:1199px) { 
        font-size: 32px;
        line-height:40px;
    }
    @media screen and (max-width:991px) { 
        font-size: 30px;
        line-height:40px;
    }
    @media screen and (max-width:767px) { 
        font-size: 25px;
        line-height:35px;
    }
`;
export const SectionTitleDropdown = styled.div`

`;
export const BlogSection = styled.section`
    padding-top: 158px;
    background: #F1FEFF;
    margin-top: -80px;
    padding-bottom: 70px;
    @media screen and (max-width:991px) { 
        padding-top: 135px;
        padding-bottom: 50px;
    }
`;
export const HelpPeopleNowSection = styled.section`
    padding-top: 57px;
    padding-left: 30px;

    @media screen and (max-width:991px) { 
        padding-top: 50px;
        padding-left: 0px;

    }
`;
export const HelpPeopleColLeft = styled.div``;
export const HelpPeopleColRight = styled.div`
    padding-right: 0;
`;
export const HelpPeopleColInner = styled.div`
    max-width: 436px;
    width: 100%;
    margin: 45px 0 0 auto;
    
    @media only screen and (max-width: 1440px){
        max-width: 488px;
    }
    @media screen and (max-width:991px) { 
        margin: 0 ;
    }

`;
export const HelpPeopleSubTitle = styled.h3`
    display: flex;
    align-items: center;
    column-gap: 10px;
    margin-bottom: 30px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 20px;
    font-weight: 500; 
    line-height: 30px;
    @media screen and (max-width:767px) {
        margin-bottom: 20px;
     }
    img{
        margin-top: -3px;
    }
`;
export const HelpPeopleTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 36px;
    font-weight: bold;
    line-height: 54px;
    margin-bottom: 10px;
    @media screen and (max-width:1199px) { 
        font-size: 32px;
        line-height:40px;
    }
    @media screen and (max-width:991px) { 
        font-size: 30px;
        line-height:40px;
    }
    @media screen and (max-width:767px) { 
        font-size: 25px;
        line-height: 35px;
    }
`;
export const HelpPeopleText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 14px;
`;
export const HelpPeopleList = styled.ul`
    padding: 0;
    list-style-type: none;
    margin: 0;
`;
export const HelpPeopleListItem = styled.li`
    display: flex;
    align-items: center;
    column-gap: 17px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 8px;

    &:last-child{
        margin-bottom: 0px;
    }
`;
export const HelpPeopleBtn = styled.div`
    margin-top: 30px;
`;
export const HelpPeopleImage = styled.div`
    position: relative;
    margin-top: 20px;
    @media screen and (max-width:575px) {
        margin-top: 85px;
    }
    img{
        width: 100%;
        height: auto;
        object-fit: cover;
        @media screen and (max-width:575px) {
            height: auto;
        }
    }
`;
export const HelpPeopleCount = styled.div`
    position: absolute;
    top: 0;
    left: 10%;
    right: auto;
    bottom: auto;
    background: #FFA317;
    border-radius: 30px 0px;
    max-width: 362px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 26px 20px 34px;
    column-gap: 14px;
    @media screen and (max-width:1199px) {
        padding: 15px 20px 15px 30px;
        border-radius: 20px 0px;
    }
    @media screen and (max-width:575px) {
        left: 0;
        padding: 15px 20px 15px 30px;
        border-radius: 20px 0px;
        top: -56px;
     }
`;
export const PeopleHelpCount = styled.span`
    &.people-help-count {
        display: block;
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 50px;
        font-weight: bold;
        line-height: 72px;
        @media screen and (max-width:1199px) {
            font-size:40px;
           line-height:50px;
        }
        @media screen and (max-width:767px) {
            font-size: 30px;
           line-height:50px;
        }
    }
`;
export const PeopleHelpText = styled.span`
    &.people-help-text {
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }
`;